"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var __1 = require("../");
function LocalhostCheck(_a) {
    var _b = _a.color, color = _b === void 0 ? 'primary' : _b;
    var isLocalhost = Boolean(window.location.hostname === 'localhost' ||
        // [::1] is the IPv6 localhost address.
        window.location.hostname === '[::1]' ||
        // 127.0.0.1/8 is considered localhost for IPv4.
        window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));
    return (jsx_runtime_1.jsx(jsx_runtime_1.Fragment, { children: isLocalhost && (jsx_runtime_1.jsx(jsx_runtime_1.Fragment, { children: jsx_runtime_1.jsx(__1.FloatingActionButtonWrapper, __assign({ left: true }, { children: jsx_runtime_1.jsx(__1.Tooltip, __assign({ title: "This app is running on localhost" }, { children: jsx_runtime_1.jsx(__1.FloatingActionButton, __assign({ color: color }, { children: jsx_runtime_1.jsx(__1.Icon.Build, {}, void 0) }), void 0) }), void 0) }), void 0) }, void 0)) }, void 0));
}
exports.default = LocalhostCheck;
//# sourceMappingURL=LocalhostCheck.js.map